import { Panel } from "src/components/Panel/Panel.tsx";
import { FormField } from "src/components/Form/fields/FormField.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { useState } from "react";
import { Accordion } from "@radix-ui/react-accordion";
import { PriceListRow } from "./PriceListRow/PriceListRow.tsx";
import { useList } from "src/system/useList.tsx";
import {
  PriceListItemCalculateType,
  type PriceListResource,
  type ProductPriceListItem,
} from "@exonn/js-sdk";
import { ResourceEnum } from "src/constants/constants.ts";
import { useFormContext, useWatch } from "react-hook-form";
import type { EditVariantComponentFormValues } from "src/admin/forms/variant-component/edit/edit.config.tsx";
import { SelectPriceLists } from "src/admin/modals/product/SelectPriceLists/SelectPriceLists.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const Price = () => {
  const [priceListModalOpen, setPriceListModalOpen] = useState(false);
  const { t } = useTranslation(TranslationNamespaceEnum.PricePanel);

  const { control, getValues, setValue } =
    useFormContext<EditVariantComponentFormValues>();
  const { data, isLoading: isPriceListsLoading } = useList<PriceListResource>({
    resource: ResourceEnum.PriceList,
    include: ["currency"],
    queryOptions: {
      refetchOnMount: true,
    },
  });

  const priceLists = data?.data || [];
  const priceListsItems = useWatch({ control, name: "priceListItems" });

  const assignedPriceLists = priceLists.filter((priceList) => {
    if (priceListsItems[priceList.id]) {
      return true;
    }
    return priceList.calculate_type !== null;
  });

  const handleSave = ({
    tempSelectedPriceListIds,
  }: {
    tempSelectedPriceListIds: string[];
  }) => {
    const { priceListItems } = getValues();

    const nextPriceListItems = priceLists.reduce(
      (acc, priceList) => {
        const isAutomaticPriceList = priceList.calculate_type !== null;
        const isSelected = tempSelectedPriceListIds.includes(priceList.id);
        const existingPriceListItem = priceListItems?.[priceList.id];

        if (isAutomaticPriceList && !isSelected) {
          return {
            ...acc,
            [priceList.id]: {
              calculate_type: PriceListItemCalculateType.Inactive,
              calculate_value: "0",
              calculate_from: "selling_price",
              is_calculate_round: false,
            },
          };
        }

        if (!isAutomaticPriceList && isSelected) {
          if (
            existingPriceListItem &&
            existingPriceListItem.calculate_type !==
              PriceListItemCalculateType.Inactive
          ) {
            return {
              ...acc,
              [priceList.id]: existingPriceListItem,
            };
          }
          return {
            ...acc,
            [priceList.id]: {
              calculate_type: PriceListItemCalculateType.Absolute,
              calculate_value: "0",
              calculate_from: "selling_price",
              is_calculate_round: false,
            },
          };
        }

        if (!isAutomaticPriceList && !isSelected && existingPriceListItem) {
          return {
            ...acc,
            [priceList.id]: {
              calculate_type: PriceListItemCalculateType.Inactive,
              calculate_value: "0",
              calculate_from: "selling_price",
              is_calculate_round: false,
            },
          };
        }

        return acc;
      },
      {} as { [id: string]: ProductPriceListItem },
    );

    setValue("priceListItems", nextPriceListItems, {
      shouldDirty: true,
    });
    setPriceListModalOpen(false);
  };
  const priceListItems = useWatch({
    name: `priceListItems`,
    control,
  });

  const selectedPriceListIds = priceLists
    .filter((priceList) => {
      if (priceListItems[priceList.id]) {
        return (
          priceListItems[priceList.id].calculate_type !==
          PriceListItemCalculateType.Inactive
        );
      }

      return priceList.calculate_type !== null;
    })
    .map((priceList) => priceList.id);

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>{t("panel.title")}</Panel.Title>
      </Panel.Header>
      <Panel.Body>
        <Panel.FormFields>
          <div css={{ display: "flex", gap: 10 }}>
            <FormField name={"price"} />
            <FormField name={"quantity"} />
          </div>
          {/*<H6>Tax</H6>*/}
          {/*{props.row?.vats?.map((vat) => (*/}
          {/*  <div key={vat.id} css={vatRowStyles}>*/}
          {/*    {vat.title}*/}
          {/*    <H6>{vat.vat_percent + " %"}</H6>*/}
          {/*  </div>*/}
          {/*))}*/}
          {!!priceLists?.length && !!assignedPriceLists.length && (
            <Accordion type="multiple">
              {assignedPriceLists.map(({ id }) => {
                return <PriceListRow key={id} id={id} />;
              })}
            </Accordion>
          )}
          {!isPriceListsLoading && (
            <ButtonV2
              css={{ alignSelf: "flex-start" }}
              size="sm"
              startAdornment={<i className="icon-15-price_lists" />}
              onClick={() => {
                setPriceListModalOpen(true);
              }}
            >
              Preislisten
            </ButtonV2>
          )}

          {priceListModalOpen && (
            <SelectPriceLists
              selectedPriceListIds={selectedPriceListIds}
              onSave={handleSave}
              priceLists={priceLists}
              onClose={() => setPriceListModalOpen(false)}
            />
          )}
        </Panel.FormFields>
      </Panel.Body>
    </Panel>
  );
};

// const vatRowStyles = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   gap: 10,
//   padding: 10,
//   fontSize: 14,
//   borderBottom: "1px solid lightgrey",
// };
